// src/features/welfare/ui/WelfareLayout.tsx
import * as React from "react";
import { Outlet } from "react-router-dom";
import { SegmentedIconSelector, SegmentedOption } from "@src/ui/compoments/segmented-icon-selector";
import { Car, Moon } from "lucide-react";

// 1️⃣ Define the set of types once
export type InstanceType = "carMaintenance" | "yoga";
const OPTIONS: SegmentedOption<InstanceType>[] = [
  { key: "carMaintenance", label: "Car Maintenance",      Icon: Car      },
  { key: "yoga",      label: "Yoga", Icon: Moon     },
];

// 2️⃣ Create a Context to share the selection
export const WelfareTypeContext = React.createContext<{
  instanceType: InstanceType;
  setInstanceType: React.Dispatch<React.SetStateAction<InstanceType>>;
}>(null!);

export function WelfareLayout() {
  const [instanceType, setInstanceType] = React.useState<InstanceType>(OPTIONS[0].key);

  return (
    <WelfareTypeContext.Provider value={{ instanceType, setInstanceType }}>
      <SegmentedIconSelector
        options={OPTIONS}
        selected={instanceType}
        onChange={setInstanceType}
      />
      <div className="mt-4">
        <Outlet />
      </div>
    </WelfareTypeContext.Provider>
  );
}
